import { questTitle } from '../data/guide/quests'
import { canonicalNpcId } from '../data/guide/npcIdentity'
import type { WorldData } from '../types/world'

export type NpcQuestService = { questId: number; title: string; levelMin?: number; requiredQuestId?: number }

/**
 * Misiones que atiende un NPC según 37_quest_rules.npc_monster_id (ID exacto de 06_monsters).
 * Es un dato de configuración: no depende de que el NPC tenga ubicación exportada.
 */
export function questsServedBy(w: WorldData | undefined, monsterId: number | undefined): NpcQuestService[] {
  if (!w || monsterId === undefined) return []
  const target = canonicalNpcId(monsterId)
  const byQuest = new Map<number, NpcQuestService>()
  w.quests.rules.forEach((r) => {
    // Un NPC unificado (234 → 226) aporta sus misiones a la ficha principal.
    if (r.npcMonsterId === undefined || canonicalNpcId(r.npcMonsterId) !== target) return
    const cur = byQuest.get(r.questId) ?? { questId: r.questId, title: questTitle(r.questId) }
    if (r.levelMin !== undefined && (cur.levelMin === undefined || r.levelMin < cur.levelMin)) cur.levelMin = r.levelMin
    if (r.requiredQuestId !== undefined && r.requiredQuestId !== r.questId) cur.requiredQuestId = r.requiredQuestId
    byQuest.set(r.questId, cur)
  })
  return Array.from(byQuest.values()).sort((a, b) => a.questId - b.questId)
}

/** npc_monster_id de 37 que no existen en 06_monsters (FK no declarada en 00_control, se valida igual). */
export function unresolvedQuestNpcIds(w: WorldData): number[] {
  return Array.from(new Set(w.quests.rules.map((r) => r.npcMonsterId).filter((id): id is number => id !== undefined && !w.monsters.has(id))))
}

/** Enlace a la guía de la misión (evoluciones). */
export const questGuidePath = (questId: number) => (questId <= 1 ? '/guia/evoluciones#sebina' : questId <= 3 ? '/guia/evoluciones#marlon' : questId <= 6 ? '/guia/evoluciones#tercera' : undefined)
